import * as React from "react";

import { makeStyles } from "@material-ui/core";
import Cookies from "universal-cookie";
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router";

import { selectLoginOpen, setLogin } from "../redux/slices/publicSlice";

const cookies = new Cookies();
const isAuthed = cookies.get("isLoggedIn") === "1";

const staticTokenOnLocal = () => {
  const isWindow = typeof window;
  if (isWindow !== "undefined") {
    if (
      window?.location?.host === "localhost:3500" ||
      window?.location?.host === "localhost:3000" ||
      window?.location?.host === "localhost:4000"
    ) {
      return true;
    }
    return isAuthed;
  }
  return isAuthed;
};

const isAuthenticated = () => {
  // const isAuthed = true;
  // return true;
  return staticTokenOnLocal();
};

const LoginRequired = () => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setLogin(true));
  }, [dispatch]);
  return <Redirect to="/" />;
};

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
  },
}));
const PrivateRoute = (props) => {
  const classes = useStyles();
  const logOpen = useSelector(selectLoginOpen);
  const [authed, setAuthed] = React.useState(isAuthenticated());
  const { children } = { ...props };
  React.useEffect(() => {
    setAuthed(isAuthenticated());
  }, [logOpen]);

  return (
    <div className={classes.root} {...props}>
      {authed ? children : <LoginRequired />}
    </div>
  );
};

export { isAuthenticated };
export default PrivateRoute;
